module.exports = __webpack_public_path__ + "media/images/heart--full-5f93c85f696b532804fe7e1b793cfd09.svg";